/**
 * Account-level linked accounts API service
 */

import apiClient from './index.js';

export class LinkedAccountsApi {
  static async requestLink(token, targetIdentifier) {
    return apiClient.post('/users/v1/link/request', token, { targetIdentifier });
  }

  static async acceptLink(token, requesterUserId) {
    return apiClient.post('/users/v1/link/accept', token, { requesterUserId });
  }

  static async unlinkAccount(token, linkedUserId) {
    return apiClient.post('/users/v1/link/unlink', token, { linkedUserId });
  }
}

export default LinkedAccountsApi;
